import { DropdownItemProps } from 'semantic-ui-react'

export interface SearchableDropdownOption extends DropdownItemProps {
  /**
   * Optional pre-built haystack string used by `searchDropdownOptions`. When
   * present, the search query is matched against this instead of `text`. Use
   * it to make the dropdown searchable across fields that aren't shown in
   * the closed display (e.g. email and external ID for a team member whose
   * `text` is just the name).
   */
  searchableText?: string
}

/**
 * Custom Semantic UI Dropdown `search` function. Matches the typed query
 * against `searchableText` when present, otherwise falls back to `text`.
 * Case-insensitive, substring match.
 *
 * Pass directly as the `search` prop:
 *   <Dropdown search={searchDropdownOptions} ... />
 */
export function searchDropdownOptions(
  options: DropdownItemProps[],
  query: string
): DropdownItemProps[] {
  const q = query.trim().toLowerCase()
  if (!q) {
    return options
  }
  return options.filter((opt) => {
    const haystack = String((opt as SearchableDropdownOption).searchableText ?? opt.text ?? '')
    return haystack.toLowerCase().includes(q)
  })
}



// WEBPACK FOOTER //
// ./src/libs/dropdown-search/index.ts